// App.jsx or App.tsx (whichever extension you use)

import React, { Component } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import * as Pages from "./pages";
import styled from "styled-components";
import routes from "./components/routes";
import CorporateRoutesProvider from "router/corporate";
import Router from "router";
import withSetupRouteProtection from "components/hoc/SetupRouteProtection";
import "react-tooltip/dist/react-tooltip.css";

// Create a component to decide what to render on root route
function HomePageSelector() {
  const location = useLocation();

  if (location.pathname !== "/") {
    return <div>Page Not Found</div>; 
  }

  if (window.location.hostname.includes("corporate")) {
    return <CorporateRoutesProvider />;
  } else {
    return <Pages.ManagerDashBoardComponent />;
  }
}

const ProtectedPlanSetup = withSetupRouteProtection(Pages.PlanSetup, ['/plan-setup']);
const ProtectedBenefitSelect = withSetupRouteProtection(Pages.BenefitSelect, ['/benefits']);
const ProtectedFlexSetupBenefits = withSetupRouteProtection(Pages.FlexSetupBenefits, ['/flex/setup/benefits']);
const ProtectedFlexSetupTPA = withSetupRouteProtection(Pages.FlexSetupTPA, ['/flex/setup/tpa', '/plan-setup/tpa']);
const ProtectedFlexSetupGPA = withSetupRouteProtection(Pages.FlexSetupGPA, ['/flex/setup/gpa']);
const ProtectedFlexPricingSetup = withSetupRouteProtection(Pages.FlexPricingSetup, ['/flex/setup/ghi']);
const ProtectedProductAttribute = withSetupRouteProtection(Pages.ProductAttribute, ['/flex/setup/attributes']);
const ProtectedFlexUploadDocument = withSetupRouteProtection(Pages.FlexUploadDocument, ['/flex/setup/upload-documents']);
const ProtectedInsurerPage = withSetupRouteProtection(Pages.InsurerPage, ['/plan-setup/insurer']);
const ProtectedCoverageDocPage = withSetupRouteProtection(Pages.CoverageDocPage, ['/plan-setup/coverage']);

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <main>
          <Routes>
            {/* Root route */}
            <Route path={`/${routes.ROOT}`} element={<HomePageSelector />} />

            {/* Other routes */}
            <Route path={`/${routes.PAYMENTSUMMARY}`} element={<Pages.PaymentSummaryPage />} />
            <Route path={`/${routes.UPLOADPOLICYDOC}`} element={<Pages.uploadPolicyDocPage />} />
            <Route path={`/${routes.COMPANY_INFO}/:type`} element={<Pages.companyInfo />} />
            <Route path={`/${routes.COMPANY_SETUP}/:type`} element={<Pages.companySetup />} />
            <Route path={`/${routes.PLAN_SELECTION}`} element={<Pages.planSelection />} />
            <Route path={`/${routes.BUILD_PLAN}/:type`} element={<Pages.buildyourPlan />} />
            <Route path={`/${routes.UPLOAD_EXCEL}/:type`} element={<Pages.UploadExcel />} />
            <Route path={`/${routes.CARE_DASHBOARD}`} element={<Pages.careDashboard />} />
            <Route path={`/${routes.UPLOAD_POLICYNOS}`} element={<Pages.UploadPolicyNos />} />
            <Route path={`/${routes.GMC_PAYMENTSUMMARY}`} element={<Pages.GmcPaymentSummary />} />
            <Route path={`/${routes.ENDORSEMENT_EDIT}`} element={<Pages.UploadEndorsement />} />
            <Route path={`/${routes.UPLOAD_RATECHART}/:type`} element={<Pages.UploadRatechart />} />
            <Route path={`/${routes.RATE_CHART}/:type`} element={<Pages.RateChart />} />
            <Route path={`/${routes.UPLOAD_DOCUMENT}/:type`} element={<Pages.UploadDocument />} />
            <Route path={`/${routes.ADD_DELETE_EMPLOYEE}/`} element={<Pages.AddDeleteEmoployee />} />
            <Route path={`/${routes.PREPURCHASE_RECOMMENDATION}/`} element={<Pages.PrePurchaseRecommendation />} />
            <Route path={`/${routes.THANKYOU_PAGE}/`} element={<Pages.ThankYouPage />} />
            <Route path={`/${routes.THANKYOU_PAGE_MESSAGE}/`} element={<Pages.ThankYouMessage />} />
            <Route path={`/${routes.MANAGER_DASHBOARD}/`} element={<Pages.ManagerDashBoardComponent />} />
            <Route path={`/${routes.SIGNUP}/`} element={<Pages.SignUp />} />
            <Route path={`/${routes.FORGET_PASSWORD}/`} element={<Pages.ForgetPassword />} />
            {/* Plan Setup */}
            <Route path={`/${routes.INSURANCE_SETUP}/`} element={<Pages.InsuranceSetup />} />
            <Route path={`/${routes.GMC_SETUP}/`} element={<Pages.GmcSetup />} />
            <Route path={`/${routes.GPA_SETUP}/`} element={<Pages.GpaGtlSetup />} />
            <Route path={`/${routes.GTL_SETUP}/`} element={<Pages.GpaGtlSetup />} />
            <Route path={`/${routes.GMC_RATECHART}/`} element={<Pages.GmcRatechart />} />
            {/* CD Balance */}
            <Route path={`/${routes.UPLOAD_CDEXCEL}`} element={<Pages.UploadCdExcel />} />
            <Route path={`/${routes.VIEW_CD_BALANCE}`} element={<Pages.ViewCdBalance />} />
            <Route path={`/${routes.VIEW_CD_TBALE}`} element={<Pages.ViewCdTable />} />
            {/* Upload Documents */}
            <Route path={`/${routes.SELECT_PLAN}/`} element={<Pages.SelectPlan />} />
            <Route path="/carelist" element={<Pages.CaredashboardList />} />
            <Route path="/e-card-preview/download" element={<Pages.ECardDownload />} />
            <Route path="/e-card-preview" element={<Pages.ECardPreview />} />
            {/* Removed duplicate /carelist route */}
            {/* Other setup and pages */}
            <Route path={`/${routes.GHI_TPA_SETUP}`} element={<Pages.GhiSetupTPA />} />
            <Route path={`/${routes.FLEX_BENEFITS_SETUP}`} element={<ProtectedFlexSetupBenefits />} />
            <Route path={`/${routes.FLEX_TPA_SETUP}`} element={<ProtectedFlexSetupTPA />} />
            <Route path={`/${routes.FLEX_GPA_SETUP}`} element={<ProtectedFlexSetupGPA />} />
            <Route path={`/${routes.FLEX_PRICING_SETUP}`} element={<ProtectedFlexPricingSetup />} />
            <Route path={`/${routes.FLEX_ATTRIBUTE_SETUP}`} element={<ProtectedProductAttribute />} />
            <Route path={`/${routes.FLEX_UPLOAD_DOCUMENTS}`} element={<ProtectedFlexUploadDocument />} />
            <Route path={`/${routes.FLEX_DASHBOARD}`} element={<Pages.FlexDashboardPage />} />
            <Route path={`/${routes.FLEX_MASTER_DOC}`} element={<Pages.FlexMasterDocPage />} />
            <Route path={`/${routes.FLEX_EMP_UPLOAD}`} element={<Pages.FlexEmployeeSheetUpload />} />
            <Route path={`/${routes.FLEX_ERROR_FILE}`} element={<Pages.FlexError />} />
            <Route path={`/${routes.FLEX_PRODUCT_STATUS}`} element={<Pages.FlexProductsOverview />} />
            <Route path={`/${routes.FLEX_PRODUCT_UPLOAD}`} element={<Pages.BulkProductUploadPage />} />
            <Route path={`/${routes.FLEX_PENDING_STATE}`} element={<Pages.FlexPendingStatePage />} />
            <Route path={`/${routes.ENROLMENT_HISTORY}`} element={<Pages.EnrolmentHistoryPage />} />
            <Route path={`/${routes.UNIVERSAL_INSURER_SETUP}`} element={<ProtectedInsurerPage />} />
            <Route path={`/${routes.UNIVERSAL_COVERAGE_DOC}`} element={<ProtectedCoverageDocPage />} />
            <Route path={`/${routes.GRADE_SETUP}`} element={<Pages.GradeSetupPage />} />
            <Route path="internal-test" element={<Pages.InsurerPage />} />
            <Route path="internal-test" element={<Pages.GradeSetupPage />} />
            <Route path="grade-setup/grade" element={<Pages.GradeSetupSummaryPage />} />
            {/* corporate buffer */}
            <Route path={`/${routes.PRE_CORPORATE_BUFFER}/`} element={<Pages.CorporateBufferPreIssuance />} />
            {/* universal setup */}
            <Route path={`/${routes.UNIVERSAL_BENEFITS_SETUP}/`} element={<ProtectedBenefitSelect />} />
            <Route path={`/${routes.UNIVERSAL_PLAN_SETUP}`} element={<ProtectedPlanSetup />} />
            {/* universal policyid upload */}
            <Route path={`/${routes.UNIVERSAL_PRODUCT_SELECT_UHID}`} element={<Pages.ChooseProductToUploadUHID />} />
            <Route path={`/${routes.UNIVERSAL_POLICY_ID_UPLOAD}`} element={<Pages.UploadPolicyId />} />
            <Route path={`/super-task-reupload`} element={<Pages.SuperTaskUploadagain />} />
            <Route path={`/${routes.UNIVERSAL_TPA}`} element={<ProtectedFlexSetupTPA />} />
            {/* universal setup postissuance */}
            <Route path={`${routes.UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID}`} element={<Pages.PostIssuanceUhidUpload />} />
            <Route path={`/wellness/setup/summary`} element={<Pages.BenefitSummaryComp />} />
            <Route path={`/wellness/setup`} element={<Pages.BenefitSetupComp />} />
            <Route path={`/wellness`} element={<Pages.WellnessComp />} />
            <Route path={`${routes.UPDATE_CORPORATE_BUFFER}`} element={<Pages.UpdateCorporateBuffer />} />
            <Route path={`${routes.VIEW_CORPORATE_BUFFER}`} element={<Pages.UniversalCorporateBffer />} />
            {/* universal data collection */}
            <Route path={`${routes.EMPLOYEE_DATA_COLLECTION}`} element={<Pages.UploadEmployeeData />} />
            <Route path={`${routes.EMPLPLOYEE_DATA_COLLECTION_HISTORY}`} element={<Pages.DataCollectionHistory />} />
            {/* claim support */}
            <Route path={`${routes.CLAIM_SUPPORT}`} element={<Pages.ClaimSupport />} />
            <Route path={`${routes.POST_ISSUANCE_PENDING_STATUS}`} element={<Pages.PostGetTaskSet />} />
            <Route path={`${routes.POST_ISSUANCE_DOWNLOAD_ERROR_FILE}`} element={<Pages.ErrorFileDownload />} />
            <Route path={`${routes.USER_PROFILE}`} element={<Pages.UserProfile />} />
            <Route path={`${routes.CHANGE_PASSWORD}`} element={<Pages.ChangePassword />} />
            <Route path={`${routes.UTILITIES}`} element={<Pages.UtilitiesHome />} />
            <Route path={`${routes.UTILITIES_UHID_GENERATOR}`} element={<Pages.UtilitiesUhidGenerator />} />
            {/* claim dashboard */}
            <Route path={`${routes.CLAIM_DASHBOARD}`} element={<Pages.ClaimDashboard />} />
            <Route path={`${routes.CLAIMS_SUMMARY_MIS}`} element={<Pages.ClaimsMisPage />} />
            <Route path={`${routes.CLAIMS_SUMMARY_MIS_EMPLOYEE}`} element={<Pages.ClaimsEmployeeDetailPage />} />
            <Route path="/grade-setup/exclusion" element={<Pages.ProductExclusionPage />} />
            {/* Corporate routes */}
            <Route path="/corporate/*" element={<CorporateRoutesProvider />} />
            {/* V1 routes */}
            <Route path="/v1/*" element={<Router />} />

            {/* Optional: Catch all route - Not Found Page */}
            <Route path="*" element={<div>404 - Page Not Found</div>} />
          </Routes>
        </main>
      </React.Fragment>
    );
  }
}

export default App;

// Styled component example - not directly related to the routing fix
const DivP = styled.div`
  display: flex;
  min-height: 120px;
  min-width: 140px;
  background-color: red;
`;
